<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click.stop="abrirModalInserirDocumento()">
            <span> <i class="fa fa-plus mr-2"></i> Inserir Documento </span>
        </b-button>
        <b-modal
            id="modalInserirDocumento"
            v-model="mostrarModalInserirDocumento"
            @show="preencherForm()"
        >
            <div slot="modal-title">
                Documento -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row v-if="mostrarCheckApostilamento">
                <b-col>
                    <b-form-group>
                        <label>
                            <strong>O que deseja fazer ?</strong>
                        </label>
                        <b-form-radio-group v-model="contratoApostilamento"  @change="alternaJustificativa($event)">
                            <b-form-radio value="0">
                                <strong>
                                    <span class="text-danger">Atualizar</span>
                                </strong>
                            </b-form-radio>
                            <b-form-radio value="1">
                                <strong>
                                    <span class="text-primary">Apostilar</span>
                                </strong>
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Tipo do Documento</label>
                        <b-form-select
                            :plain="true"
                            :options="tiposDocumentos"
                            v-model="tipoDocumentoId"
                            text-field="descricao"
                            value-field="tipoDocumentoId"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descrição do Arquivo <span class="text-danger">*</span></label>
                        <b-form-textarea
                            v-model="descricao"
                            :rows="4"
                            @input="$v.descricao.$touch()"
                            :state="$v.descricao.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback>A descrição do documento é obrigatória</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm=12>
                    <b-form-group>
                        <span class="text-success" v-if="isLink === true">
                            <i
                                class="fa fa-toggle-on fa-lg icon-button"
                                title="Trocar Para Arquivo"
                                @click.stop="alternarLinkArquivo('D')"
                            ></i>
                        </span>
                        <span class="text-secondary" v-if="isLink === false">
                            <i
                                class="fa fa-toggle-off fa-lg icon-button"
                                title="Trocar Para Link"
                                @click.stop="alternarLinkArquivo('A')"
                            ></i>
                        </span>
                        <label v-if="isLink"> Link</label>
                        <label v-if="!isLink"> Arquivo</label>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="!isLink">
                <b-col sm="12">
                    <b-form-group>
                        <label>Arquivo</label>
                        <b-form-file
                            v-model="arquivo"
                            :state="Boolean(arquivo)"
                            placeholder="Selecione o arquivo..."
                            ref="arquivoInput"
                        ></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="isLink">
                <b-col sm="12">
                    <b-form-group>
                        <label>Link do Arquivo</label>
                        <b-form-textarea
                            v-model="link"
                            :rows="3"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row v-if="apostilamento || this.atualizacaoContrato()">
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa {{labelJustificativa}}</label>
                        <b-form-textarea
                            v-model="justificativaApostilamento"
                            :rows="4"
                            @input="$v.justificativaApostilamento.$touch()"
                            :state="
                                $v.justificativaApostilamento.$error
                                    ? false
                                    : null
                            "
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa {{textoInfoJustificativa}} é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModalInserirDocumento()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="confirmarSalvarDocumento()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ContratosServicos from './../ContratosServicos'
import DocumentosServicos from './DocumentosServicos'
import { situacaoContrato } from '../SituacaoContrato'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        apostilamento: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            mostrarModalInserirDocumento: false,
            obterDocumentosAtualizados: false,
            operacao: 'INSERÇÃO',
            erros: [],
            tiposDocumentos: [],
            tipoDocumentoId: '',
            descricao: '',
            arquivo: null,
            justificativaApostilamento: '',
            contratoApostilamento: null,
            labelJustificativa: '',
            textoInfoJustificativa: '',
            isLink: true,
            link: ''
        }
    },

    methods: {
        obterTiposDocumentos() {
            this.$store.dispatch('addRequest')
            DocumentosServicos.obterTiposDocumentos().then(response => {
                if (response) {
                    if (response.success) {
                        this.tiposDocumentos = response.data
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        abrirModalInserirDocumento() {
            this.mostrarModalInserirDocumento = true
        },

        fecharModalInserirDocumento() {
            this.mostrarModalInserirDocumento = false
            this.resetInserirDocumento()
            if (this.obterDocumentosAtualizados) {
                this.$emit('obterDocumentosAtualizados')
            }
        },

        resetInserirDocumento() {
            this.justificativaApostilamento = ''
            this.tipoDocumentoId = ''
            this.descricao = ''
            this.arquivo = null
            this.link = ''
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            this.obterDocumentosAtualizados = false
            this.obterTiposDocumentos()
        },

        confirmarSalvarDocumento() {
            this.$swal({
                title: 'Documento',
                html: `Confirma a inserção do documento no contrato <b>${this.contrato.vcCodigoEstruturado}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvarDocumento()
                }
            })
        },

        salvarDocumento() {
            let documentoDto = {
                idContrato: this.contrato.idContrato,
                tipoDocumentoId: this.tipoDocumentoId,
                descricao: this.descricao,
                arquivo: this.arquivo,
                justificativaApostilamento: this.justificativaApostilamento,
                isApostilamento: this.contratoApostilamento == 1 ? true : false,
                link: this.link.toString()
            }
            this.$store.dispatch('addRequest')
            DocumentosServicos.inserirDocumento(documentoDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.obterDocumentosAtualizados = true
                        this.registroSalvoComSucesso(response.data)
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        alternarLinkArquivo() {
            this.link = ''
            this.arquivo = null 
            this.isLink = !this.isLink
        },

        registroSalvoComSucesso(data) {
            this.$toast.success(
                'Registro salvo com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.fecharModalInserirDocumento()
        },

        justificativaOk() {
            if (this.apostilamento || this.atualizacaoContrato()) {
                return this.justificativaApostilamento !== ''
            }
            return true
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        aditivarContrato() {
            return (
                this.contrato.idSituacaoContrato == situacaoContrato.INICIADO_ADITIVO_CONTRATO
            )
        },

        contratoElaboracao() {
            return (
                ((this.$temAcessoView('CONT-ELAB-00') &&
                    (this.contrato.idSituacaoContrato ==
                        situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                        this.contrato.idSituacaoContrato ==
                            situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO)))
            )
        },

        atualizacaoContrato() {
            return (this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido())
        },

        alternaJustificativa(value) {
            this.contratoApostilamento = value
            if(this.contratoApostilamento == 1) {
                this.textoInfoJustificativa = 'do apostilamento'
                this.labelJustificativa = 'Apostilamento'
            } else {
                this.textoInfoJustificativa = ''
                this.labelJustificativa = ''
            }
        },

        verificaTiposAtualizacao() {
            if((this.apostilamento || this.atualizacaoContrato()) && this.contratoApostilamento != null) {
                return true
            } else if(this.contratoElaboracao() || this.aditivarContrato()) {
                return true
            }
            return false
        },

        alternaJustificativaPorAcesso() {
            if(this.$temAcessoView('CONT-ATUALIZAR-00') && this.$temAcessoView('CONT-APOST-07')) {
                this.contratoApostilamento = null
            } else if(this.$temAcessoView('CONT-ATUALIZAR-00')) {
                this.contratoApostilamento = 0
                this.alternaJustificativa(this.contratoApostilamento)
            } else if(this.$temAcessoView('CONT-APOST-07')) {
                this.contratoApostilamento = 1
                this.alternaJustificativa(this.contratoApostilamento)
            }
        }

    },

    created() {
        this.alternaJustificativaPorAcesso()
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        mostrarCheckApostilamento() {
            return (
                this.atualizacaoContrato() && this.apostilamento
            )
        },
        
        
    },

    watch: {},

    validations: {
        descricao: {
            required
        },
        tipoDocumentoId: {
            required
        },
        arquivo: {
            validarArquivo() {
                if (!this.isLink && this.arquivo != null){
                    return true   
                }
                if (this.isLink){
                    return true
                }
                return false
            }
        },
        justificativaApostilamento: {
            justificativaOk() {
                return this.justificativaOk()
            }
        },
        contratoApostilamento: {
            verficaTipoAtualizacao() {
                return this.verificaTiposAtualizacao()
            }
        },
        link: {
            validarlink() {
                if (this.isLink && this.link != ''){
                    return true   
                }
                if (!this.isLink){
                    return true
                }
                return false
            }
        }
    }
}
</script>
